import { createApi } from '@reduxjs/toolkit/query/react';

import { GetRefundsResponse, RefundOrderResponse } from './types';
import { fetchBaseQueryWithAuth } from '../../fetchBaseQuery';
import { RefundPaylinkTransactionBody } from '../paylink/types';
import { runtimeConfig } from '../../../config/runtimeConfig';

export const omsApi = createApi({
  reducerPath: 'omsApi',
  tagTypes: ['Order', 'Transaction'],
  baseQuery: fetchBaseQueryWithAuth(runtimeConfig.omsApiBaseUrl || ''),
  endpoints: (builder) => ({
    getRefunds: builder.query<GetRefundsResponse, { orderId: string; merchantId: string }>({
      query: ({ orderId, merchantId }) => ({ url: `/${orderId}/refunds`, params: { merchantId } }),
      providesTags: (_r, _e, query) => [{ type: 'Order', id: query.orderId }],
    }),
    refundPaylinkOrderTransaction: builder.mutation<
      RefundOrderResponse,
      RefundPaylinkTransactionBody
    >({
      query: ({ orderId, ...body }) => ({
        url: `/${orderId}/refund`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, params) => [{ type: 'Order', id: params?.orderId }],
    }),
  }),
});

export const { useGetRefundsQuery, useRefundPaylinkOrderTransactionMutation } = omsApi;
